const SpecialToolsPage = props => (
  <div className="content">
    <div className="m-b-lg">
      <h4 className="is-size-4 m-b-md">{props.t('common:special-tools')}</h4>
      <div className="m-b-md">
        {props.t('common:special-tools-content-1')}
      </div>
      <div className="m-b-md">{props.t('common:special-tools-content-2')}</div>
      <div className="m-b-md">{props.t('common:special-tools-content-3')}</div>
      <div>{props.t('common:special-tools-content-4')}</div>
      <div className="m-b-md">(877) 722-8336</div>
      <div>{props.t('common:special-tools-content-5')}</div>
      <div className="m-b-md">(877) 768-6657</div>
      <div>{props.t('common:special-tools-content-6')}</div>
      <div>(855) 804-7396</div>
    </div>
  </div>
)

export default SpecialToolsPage



// WEBPACK FOOTER //
// ./components/SpecialTools/index.js